export type ExampleCat = {
  id: string;
  label: string;
  items: string[];
};

export const EXAMPLE_CATS: ExampleCat[] = [
  {
    id: 'intro', label: '挨拶・自己紹介',
    items: [
      'はじめまして。結婚5年目の夫婦で、子どもを授かることを願って登録いたしました。',
      'ご覧いただきありがとうございます。30代の夫婦です。前向きにドナーを探しております。',
      'はじめまして。同性カップルとして、二人で子どもを迎えたいと考えております。',
      'こんにちは。選択的シングルマザーとして、子どもを授かることを願って登録いたしました。',
      'はじめまして。結婚10年になる夫婦です。長年の夢を叶えたく登録いたしました。',
      'ご覧いただきありがとうございます。20代後半の夫婦で、家族を増やしたいと考えております。',
      'はじめまして。女性同士のパートナーとして、二人の子どもを迎えたいと願っております。',
      'こんにちは。40代でシングルマザーとして子育てをする決意をし、登録いたしました。',
      'はじめまして。結婚3年目の夫婦です。これから家族を築いていきたいと考えております。',
      'ご覧いただき、誠にありがとうございます。落ち着いた気持ちでドナー様を探しております。',
      'はじめまして。パートナーと二人で新しい家族を迎える準備をしております。',
      'こんにちは。これまで一人で悩んでまいりましたが、勇気を出して登録いたしました。',
      'はじめまして。結婚7年目になる夫婦で、これまで様々な選択肢を検討してまいりました。',
      'ご覧いただきありがとうございます。パートナーと二人、穏やかな気持ちで探しております。',
      'はじめまして。30代の女性です。将来設計として子どもを授かりたいと考えております。',
      'こんにちは。同性カップルとして、家族の形を模索しながら登録いたしました。',
      'はじめまして。結婚後しばらく夫婦二人の時間を過ごし、家族を迎える準備が整いました。',
      'ご覧いただきありがとうございます。長年連れ添った夫婦として、新しい一歩を踏み出したいと思います。',
      'はじめまして。これまでの経験を糧に、前向きな気持ちでドナー様を探しております。',
      'こんにちは。慎重に検討を重ねたうえで、登録を決意いたしました。どうぞよろしくお願いいたします。',
    ],
  },
  {
    id: 'background', label: 'これまでの経緯',
    items: [
      'これまで体外受精を含む不妊治療を続けてまいりましたが、なかなか良いご縁に恵まれませんでした。',
      '夫の無精子症により、自然妊娠が難しい状況です。ドナー様のご協力をお願いしたく、登録いたしました。',
      '自然な形での妊娠が難しく、信頼できるドナー様を探すことにいたしました。',
      '時間をかけて家族で話し合い、提供という選択にたどり着きました。',
      '数年にわたり人工授精にも取り組んでまいりましたが、思うような結果が得られませんでした。',
      '同性カップルのため、第三者の方のご協力が必要となり、登録を決意いたしました。',
      '選択的シングルマザーとして子どもを授かるため、ドナー様を探すことにいたしました。',
      'これまで婦人科での検査や治療を重ねてまいりましたが、時間的な制約もあり別の方法を検討しております。',
      '妻の年齢的な事情もあり、なるべく早く一歩を踏み出したいと考えております。',
      '何度か流産を経験し、悩んだ末にこの方法にたどり着きました。',
      '不妊治療専門のクリニックにも通いましたが、経済的・身体的な負担を考え、別の道を探すことにいたしました。',
      '夫婦でじっくり話し合いを重ね、ドナー様のご協力を得るという結論に至りました。',
      'これまで自分たちなりに情報を集め、慎重に検討を重ねてまいりました。',
      '治療を続けるなかで、一人の力では難しいと感じ、登録することにいたしました。',
      'パートナーとの関係のなかで、第三者の方の力をお借りする選択をいたしました。',
      'これまで様々な病院やクリニックを回りましたが、良い方向性が見えず登録に至りました。',
      '家族や周囲の理解を得ながら、少しずつ準備を進めてまいりました。',
      '年齢のことも考え、なるべく早めに行動を起こしたいと考えております。',
      '一人で子どもを育てる決意をし、そのための第一歩として登録いたしました。',
      'これまでの経緯を経て、誠実なご縁を大切にしたいという思いに至りました。',
    ],
  },
  {
    id: 'method', label: '希望する提供方法',
    items: [
      '提供方法はシリンジ法を希望しております。',
      'タイミング法は考えておらず、シリンジ法のみでお願いしたいと考えております。',
      '提供方法については、双方が安心できる形をご相談のうえ決められればと思います。',
      '排卵日に合わせて、シリンジ法でのご提供をお願いできればと考えております。',
      '直接お会いしての採取ではなく、郵送等での対応も可能な方を希望しております。',
      '提供の頻度や方法については、事前にしっかりとすり合わせをさせていただきたいです。',
      'まずはメッセージでやり取りをさせていただき、方法については追ってご相談できればと思います。',
      '通院先の指定がある場合はご相談させていただければ幸いです。',
      'お互いのスケジュールを調整しながら、無理のない形で進めたいと考えております。',
      '提供の場所や日程については、柔軟に対応させていただきます。',
      '遠方にお住まいの場合でも、対応可能な方法があればご相談させてください。',
      '提供に際しての条件（頻度・期間など）は事前に明確にしたうえで進めたいと思います。',
      'クリニックでの人工授精を予定しており、そちらでの提供にご協力いただける方を希望します。',
      '自宅での採取・受け渡しを想定しております。詳細はメッセージでご相談させてください。',
      '複数回にわたるご提供をお願いする可能性があるため、その旨ご了承いただける方を希望します。',
      '排卵検査薬を使用してタイミングを合わせたいと考えております。',
      '提供方法について特にこだわりはなく、ドナー様のご都合に合わせて調整したいと思います。',
      '安全面を重視し、感染症検査の結果を確認したうえで進めたいと考えております。',
      '提供当日の詳細な流れについては、事前にメッセージで丁寧にすり合わせさせてください。',
      '初めての試みのため、分からないことも多いですが、ご相談しながら進めさせていただければ幸いです。',
    ],
  },
  {
    id: 'wish', label: 'ドナーへの希望',
    items: [
      '本人確認と性病検査の結果を共有いただける方を希望しております。',
      '提供前に性病検査を受けていただける方を希望しております。',
      '健康状態を共有いただける方、誠実にやり取りいただける方を希望します。',
      '長期的に複数回のご提供が可能な方ですと、大変ありがたく存じます。',
      '過去の提供実績がある方ですと、安心してお願いできます。',
      'ご自身やご家族の遺伝性疾患の有無について、正直にお話しいただける方を希望します。',
      '連絡がスムーズに取れる方、レスポンスの早い方を希望しております。',
      '秘密保持について、しっかりとご理解いただける方にお願いしたいです。',
      'お子様の将来を第一に考え、誠実に対応してくださる方を希望します。',
      '継続的にご協力いただける方ですと、非常に助かります。',
      '生活習慣（喫煙・飲酒など）について正直にお伝えいただける方を希望します。',
      'ご自身の身体的特徴（身長・体型・血液型など）を詳しく教えていただける方を希望します。',
      '学歴や職業について、差し支えない範囲でお伺いできる方を希望しております。',
      '将来的にお子様との関わり方について、事前にすり合わせができる方を希望します。',
      '金銭的な条件について、事前に明確にご提示いただける方を希望します。',
      '近隣にお住まいの方、もしくは無理のない範囲で対応いただける方を希望します。',
      '落ち着いた対応をしてくださる方、誠意を持って接してくださる方を希望します。',
      '複数の候補者様の中から、じっくりお話しさせていただいたうえで決めたいと考えております。',
      'ご結婚されている方、パートナーがいらっしゃる方でもご相談可能です。',
      'これまでの提供経験について、詳しく教えていただける方を希望しております。',
    ],
  },
  {
    id: 'closing', label: '締めの言葉',
    items: [
      '誠実なやり取りを心がけますので、どうぞよろしくお願いいたします。',
      'まずはメッセージにて、やり取りさせていただければと思います。',
      '最後までお読みいただきありがとうございました。良いご縁がありますように。',
      'ご不明な点があれば、お気軽にメッセージにてお問い合わせください。',
      '慎重に、しかし前向きに進めていきたいと考えております。何卒よろしくお願いいたします。',
      '良いご縁に恵まれることを願っております。ご検討のほどよろしくお願いいたします。',
      'お互いに納得のいく形で進められればと思います。ご連絡をお待ちしております。',
      '不安な点もありますが、誠意を持って対応させていただきます。',
      '時間をかけてでも、信頼できる方とのご縁を大切にしたいと考えております。',
      'ご協力いただける方がいらっしゃいましたら、ぜひメッセージをお送りください。',
      '些細なことでも構いませんので、気になる点はお気軽にご質問ください。',
      '丁寧なやり取りを心がけますので、どうぞよろしくお願い申し上げます。',
      '家族となる大切な一歩ですので、誠実に向き合っていきたいと思います。',
      'どうぞ末永く、良いお付き合いができればと願っております。',
      'ご縁がありましたら、心から感謝申し上げます。よろしくお願いいたします。',
      'まずはお互いを知るところから始められればと思います。',
      'ご協力いただける方には、感謝の気持ちを込めて誠実に対応いたします。',
      '不躾なお願いではございますが、何卒ご検討いただけますと幸いです。',
      '焦らず、じっくりとお付き合いできる方とのご縁を願っております。',
      '最後までご覧いただき、ありがとうございました。ご連絡をお待ちしております。',
    ],
  },
];

export const pickRandomItems = (items: string[], n: number): string[] => {
  const shuffled = [ ...items ];
  for (let i = shuffled.length - 1; i > 0; i-- ) {
    const j = Math.floor(Math.random() * (i + 1));
    [ shuffled[i], shuffled[j] ] = [ shuffled[j], shuffled[i] ];
  }
  return shuffled.slice(0, n);
};
